import React, { createContext, useContext, useState, useEffect } from 'react';
import translations from '../translations/translations.json';

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('mr');

  useEffect(() => {
    document.documentElement.lang = language;
  }, [language]);

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'en' ? 'mr' : 'en');
  };

  const t = (key, variables = {}) => {
    const keys = key.split('.');
    let value = translations[language] || {};

    for (const k of keys) {
      value = value?.[k];
    }

    if (typeof value === 'string' && variables) {
      Object.entries(variables).forEach(([k, v]) => {
        value = value.replace(`{{${k}}}`, v);
      });
    }

    return value || key;
  };

  return (
    <LanguageContext.Provider value={{ language, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};
